import { render } from "./proccess.vue?vue&type=template&id=2d119023"
import script from "./proccess.vue?vue&type=script&lang=js"
export * from "./proccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__